import React from "react";
import { Box, Typography } from "@mui/material";

const ExpoPlannerBuilder = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      width="100vw"
    >
      <Typography variant="h4" fontWeight="bold">
        ExpoPlanner Builder
      </Typography>
    </Box>
  );
};

export default ExpoPlannerBuilder;
